import React, { useContext } from 'react'
import { Modal } from 'react-bootstrap'
import { PlanesContext } from '../LFPlanes';

export const ModalRetencion = ({ retroactividadSeleccionada, setRetroactividadSeleccionada, stripColor, plan, showModal = false, setShowModal = () => { } }) => {
    const {
        getData,
        notaPopup
    } = useContext(PlanesContext);
    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={'modal-content-rcpa'}
        >
            <Modal.Header className="p-0" closeButton></Modal.Header>
            <Modal.Body>
                <div className="col-12 p-0">
                    <div
                        className="w-100 font-mex text-center font-20px mt-4 "
                    >
                        <h4>¡Has elegido!</h4>
                    </div>
                    <div
                        className="w-100 font-mex text-mex text-center font-20px mt-4 "
                        style={{ backgroundColor: stripColor, paddingBottom: '0.5rem' }}
                    >
                        <h4>{plan?.nombreOpcion}</h4>
                    </div>
                    <div className="col-10 d-flex justify-content-start mt-3">
                        <b>Seleccione uno de los siguientes ítems</b>
                    </div>
                    {
                        plan?.popUp?.map((r) => (
                            <div key={r?.codigoRetroactividad + 'retroactividad'} className="row col-12 flex-wrap mt-2">
                                <div className="col-md-5 col-sm-6 d-flex justify-content-start">
                                    {r?.retroactividad}
                                </div>
                                <div className="col-md-2 col-sm-3 d-flex justify-content-start d-block">

                                </div>
                                <div className="col-md-3 col-sm-3 d-flex justify-content-start">
                                    {r?.costo}
                                </div>
                                <div className="col-md-2 col-sm-12 d-flex justify-content-end">
                                    <label className="containerCheck">
                                        <input
                                            type="checkbox"
                                            checked={retroactividadSeleccionada === r?.codigoRetroactividad}
                                            onChange={() => { setRetroactividadSeleccionada(r?.codigoRetroactividad) }}

                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        ))
                    }
                    <div className="col-12 d-flex justify-content-start mt-3">
                        <b >Nota: </b><p className="mx-3">{notaPopup}</p>
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer className="row d-flex justify-content-center">
                <button className="btn btn-primary" onClick={() => { getData(retroactividadSeleccionada, plan?.llaveSumaAsegurada, false); setShowModal(false) }}>
                    Aceptar
                </button>
            </Modal.Footer>
        </Modal>
    )
}
